import { DefaultUrlSerializer, UrlTree, UrlSegmentGroup, UrlSegment } from '@angular/router';
import { Injectable, inject } from '@angular/core';
import { IrisGlobalSandbox } from '../redux/global.sandbox';

@Injectable()
export class AppAliasUrlSerializer extends DefaultUrlSerializer {
  private readonly globalSandbox = inject(IrisGlobalSandbox);

  getAppAlias(): string | null {
    return this.globalSandbox.appAlias();
  }

  getUi2SubPathOrNull(url: string): string {
    if (!url) {
      return null;
    }
    const newAngularUrlQualifier = '/ui2/';
    const ui2index = url.indexOf(newAngularUrlQualifier);
    if (ui2index !== -1) {
      const newUrl = url.substring(ui2index + newAngularUrlQualifier.length);
      return `/${this.getAppAlias()}/${newUrl}`;
    }
    return null;
  }

  override serialize(tree: UrlTree): string {
    const appAlias = this.getAppAlias();

    if (!appAlias) {
      return super.serialize(tree);
    }

    const primaryGroup = tree.root.children['primary'];
    const segments = primaryGroup?.segments || [];
    const firstSegmentPath = segments[0]?.path;

    const isAlreadyPrefixed = firstSegmentPath === appAlias;

    if (isAlreadyPrefixed) {
      return super.serialize(tree);
    }

    const aliasSegment = new UrlSegment(appAlias, {});

    const newPrimaryGroup = new UrlSegmentGroup(
      [aliasSegment, ...segments],
      primaryGroup?.children || {},
    );

    const newRootChildren = {
      ...tree.root.children,
      primary: newPrimaryGroup,
    };

    const newRoot = new UrlSegmentGroup([], newRootChildren);

    const newTree = new UrlTree(newRoot, tree.queryParams, tree.fragment);
    const url = super.serialize(newTree);

    return url;
  }
}

